import { useCallback, useEffect } from 'react';
import { terminalUserLogout } from 'utils/terminal/user-logout';
import { IS_KIOSK_GENERIC } from 'constants/app/configs';

interface EventData {
  action: string;
  data: {
    image: string;
  };
}

export const useMessageListener = () => {
  const handleReceiveMessage = useCallback((event: MessageEvent<EventData>) => {
    switch (event.data.action) {
      case 'printTicket':
        window.external.printBase64Ticket(event.data.data.image);
        return;
      case 'sessionElapsed':
        terminalUserLogout();
        return;
      default:
        return;
    }
  }, []);

  useEffect(() => {
    if (IS_KIOSK_GENERIC) {
      window.addEventListener('message', handleReceiveMessage, false);
    }
    return () => {
      if (IS_KIOSK_GENERIC) {
        window.removeEventListener('message', handleReceiveMessage, false);
      }
    };
  }, []);
};
